'use strict';

/*
  Paypal payment class implementing Braintree payments.
*/
function BTPaypalPayment() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_BTPayment];

  /* Set _BTPayment required dependencies */
  this.requiredBtDependencies = {
    client: true,
    'paypal-checkout': true
  };

  /*
    Initialize paypal payment.
     Arguments:
      node[HTMLElement]:
        Container where the Paypal button will be created
  */
  this.initPaypalPayment = function (node) {
    this._paypalButtonNode = node;
    this.initBTPayment();
  };

  this.onLoadPaypalPaymentError = function () {
    // .. paypal initialization error
  };

  this.onPaypalReady = function () {
    // .. paypal ready
  };

  this.onClickPaypalButton = function () {
    // .. paypal onclick button
  };

  this.onPaypalAuthorize = function (payload) {
    // .. paypal authorize
  };

  this.onPaypalError = function (err) {
    // .. paypal error
  };

  this.onPaypalCancel = function (data, actions) {
    // .. paypal cancel
  };

  this.btReady = function () {
    this._createPaypalButton();
  };

  this.btError = function (error) {
    this.onLoadPaypalPaymentError();
  };

  this._createPaypalButton = function () {
    var _this = this;

    // Implement Paypal button
    braintree.paypalCheckout.create({
      client: this.btClient
    }, function (paypalCheckoutErr, paypalCheckoutInstance) {
      // Paypal creation error
      if (paypalCheckoutErr) {
        _this.onLoadPaypalPaymentError();
        return;
      }

      paypal.Button.render({
        env: _this._env,
        style: {
          color: 'black',
          label: 'checkout',
          size: 'responsive',
          shape: 'rect',
          tagline: false
        },
        payment: function () {
          this.onClickPaypalButton();
          return paypalCheckoutInstance.createPayment({
            flow: 'vault'
          });
        }.bind(_this),
        onAuthorize: function (data, actions) {
          return paypalCheckoutInstance.tokenizePayment(data).then(this.onPaypalAuthorize.bind(this));
        }.bind(_this),
        onCancel: _this.onPaypalCancel.bind(_this),
        onError: _this.onPaypalError.bind(_this)
      }, _this._paypalButtonNode).then(_this.onPaypalReady.bind(_this));
    });
  };

  this.init = function () {};

  this.initAllReady = function () {};

  this.destroy = function () {};
}